import { EnumsInterface } from "@/interfaces/EnumsInterface";

const SexAtBirth:EnumsInterface[] = [
    {id: 0, value: 0, label: "Male"},
    {id: 1, value: 1, label: "Female"},
]

export default SexAtBirth